module.exports = __webpack_public_path__ + "img/yc4.0c66251b.png";